module.exports = __webpack_public_path__ + "static/media/share.09cea59c.png";


//////////////////
// WEBPACK FOOTER
// ./src/Slip/Component/share.png
// module id = 1629
// module chunks = 0